import { ConfirmationInstructionsForm } from '@/features/tools/components/confirm-appointment/ConfirmationInstructionsForm'
import { OrganizationAuthenticationForm } from '@/features/tools/components/authenticate-caller/OrganizationAuthenticationForm'
import { ToolBuilderForm } from '@/features/tools/components/generic/ToolBuilderForm'
import { OrganizationTransferForm } from '@/features/tools/components/transfer-call/OrganizationTransferForm'
import type { AppTool, AppToolWrite } from '@/features/tools/types'

export function OrganizationToolForm({
  tool,
  onSubmit,
  onDelete,
  onCancel,
}: {
  tool: AppTool
  onSubmit: (tool: Partial<AppToolWrite>) => Promise<void>
  onDelete?: () => void
  onCancel?: () => void
}) {
  switch (tool.kind) {
    case 'confirm_appointment':
      return (
        <ConfirmationInstructionsForm
          tool={tool}
          onSubmit={onSubmit}
          onCancel={onCancel}
        />
      )
    case 'generic_webhook':
    case 'get_data':
      return (
        <ToolBuilderForm
          orgTool={tool}
          onCancel={onCancel}
          onDelete={onDelete}
          onSubmit={onSubmit}
        />
      )
    case 'authenticate_caller':
      return tool.settings ? (
        <OrganizationAuthenticationForm
          settings={tool.settings}
          onCancel={onCancel}
          onSubmit={(settings) => onSubmit({ settings })}
        />
      ) : (
        <MissingSettings name="Authenticate Caller" />
      )
    case 'configured_duty_handoff':
      return null
    case 'transfer_call':
      return tool.settings ? (
        <OrganizationTransferForm
          settings={tool.settings}
          onCancel={onCancel}
          onSubmit={(settings) => onSubmit({ settings })}
        />
      ) : (
        <MissingSettings name="Transfer Call" />
      )
  }
  throw new Error('Unsupported tool kind')
}

function MissingSettings({ name }: { name: string }) {
  return (
    <p role="alert" className="text-sm text-destructive">
      {name} settings are missing.
    </p>
  )
}
